import { AbstractControl, ValidationErrors } from '@angular/forms'
import { RxwebValidators } from '@rxweb/reactive-form-validators'

export function emailOrUrlValidator(control: AbstractControl): ValidationErrors | null {
  return !RxwebValidators.email()(control) || !RxwebValidators.url()(control) ? null : { emailOrUrl: true }
}
